module.exports = __webpack_public_path__ + "img/2.119ba461.png";